import { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import Usuario from "../../../../../models/usuario";
import { IconDotsVertical } from "@tabler/icons-react";
import ConvidarClienteDialog from "../../../conta/business/convidarClienteDialog";
import Analisar from "../analisar";

type Props = {
  cliente: Usuario;
};
export default function MenuCliente({ cliente }: Props) {
  const [openConvidar, setOpenConvidar] = useState(false);
  const [openAnalisar, setOpenAnalisar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = !!anchorEl;
  return (
    <>
      <IconButton
        size="small"
        color="default"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <IconDotsVertical />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          dense
          disabled={!!cliente.email}
          onClick={() => {
            setOpenConvidar(true);
            setAnchorEl(null);
          }}
        >
          Convidar cliente
        </MenuItem>
        <MenuItem
          dense
          disabled={!cliente?.estatisticas?.impostos}
          onClick={() => {
            setOpenAnalisar(true);
            setAnchorEl(null);
          }}
        >
          Analisar cálculos
        </MenuItem>
      </Menu>
      <ConvidarClienteDialog
        open={openConvidar}
        onClose={() => setOpenConvidar(false)}
        cliente={cliente}
      />
      {!!openAnalisar ? (
        <Analisar
          open={openAnalisar}
          onClose={() => setOpenAnalisar(false)}
          cliente={cliente}
        />
      ) : (
        <></>
      )}
    </>
  );
}
